// ======================================================================
// File Name       : UserfrontImageConstants
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const MULTILANG_TYPE = {
  NORMAL_IMAGE: 0,
  MULTILANG_IMAGE: 1,
};

export const DISPLAY_TYPE = {
  NOT_DISPLAY: 0,
  DISPLAY: 1,
};

export const USERFRONT_IMAGE_SCREEN_TYPE = {
  LOGIN: 0,
  TOP: 1,
};

/** ログイン画面画
 * 0: PC版背景
 * 1: PC版ログイン画像
 */
export const USERFRONT_IMAGE_LOGIN_TYPE = [0, 1]; // Step10.0.0

/** ログイン後トップ画面
 * 3: ヒーローエリア
 * 4: バナー1
 * 5: バナー2
 * 6: バナー3
 */
export const USERFRONT_IMAGE_TOP_TYPE = [3, 4, 5, 6];

export function isUserfrontImageLoginType(userfrontImageType) {
  return USERFRONT_IMAGE_LOGIN_TYPE.indexOf(userfrontImageType) > -1;
}

export function isUserfrontImageTopType(userfrontImageType) {
  return USERFRONT_IMAGE_TOP_TYPE.indexOf(userfrontImageType) > -1;
}

export const TITLE_OBJ_STR = {
  // Step10.0.0 START
  PC_BACKGROUND: 'ログイン背景画像',
  PC_LOGIN_LOGO: 'ログインパネルロゴ画像',
  // Step10.0.0 END
  HERO_AREA: 'メインビジュアル',
  BANNER_1: 'バナー1',
  BANNER_2: 'バナー2',
  BANNER_3: 'バナー3',
};

export const TITLE_OBJ = {
  PC_BACKGROUND: 'PC_BACKGROUND',
  PC_LOGIN_LOGO: 'PC_LOGIN_LOGO',
  HERO_AREA: 'HERO_AREA',
  BANNER_1: 'BANNER_1',
  BANNER_2: 'BANNER_2',
  BANNER_3: 'BANNER_3',
};

export const LOGIN_SCREEN_KEY_LIST = [TITLE_OBJ.PC_BACKGROUND, TITLE_OBJ.PC_LOGIN_LOGO];

export const TOP_SCREEN_KEY_LIST = [TITLE_OBJ.HERO_AREA, TITLE_OBJ.BANNER_1, TITLE_OBJ.BANNER_2, TITLE_OBJ.BANNER_3];
